export default __webpack_public_path__ + "static/media/logo_transcosmos.30221fec.svg";